<script setup lang="ts">
import type { DocumentationRow } from '@/models/current-student-advanced-standing-form/documentation'

defineProps<{
  rows: DocumentationRow[]
}>()
</script>

<template>
  <table class="table table-bordered">
    <thead>
      <tr>
        <th>Type</th>
        <th>Description</th>
        <th>Documents</th>
        <th class="narrow"></th>
      </tr>
    </thead>
    <tbody id="documentationTable">
      <tr v-if="rows.length === 0">
        <td colspan="4">No extra documentation is required.</td>
      </tr>
      <tr v-for="(row, index) in rows" :key="`${row.type}-${row.description}-${index}`">
        <td>{{ row.type }}</td>
        <td>{{ row.description }}</td>
        <td :class="{ 'alert-danger': row.required && row.attachments.length === 0 }">
          <template v-if="row.attachments.length > 0">
            <div class="attachmentGroup">
              <div v-for="attachment in row.attachments" :key="attachment.attachment_file_name">
                {{ attachment.attachment_file_name }}
              </div>
            </div>
          </template>
          <template v-else>
            None Provided
          </template>
        </td>
        <td>
          <button class="btn btn-sm" type="button" @click="row.edit">Edit</button>
        </td>
      </tr>
    </tbody>
  </table>
</template>
